"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useLookupByUserId = exports.useLookupPersonByName = void 0;
var react_1 = __importDefault(require("react"));
var client_1 = require("./contexts/client");
var LookupPersonByNameBP = __importStar(require("@hiyllo/omni-common/src/blueprints/continuity/people/lookup-person-by-name"));
var LookupPersonByUserIdBP = __importStar(require("@hiyllo/omni-common/src/blueprints/continuity/people/lookup-person-by-userid"));
var UserLookupPSB = __importStar(require("@hiyllo/omni-common/src/blueprints/continuity/people/user-lookup.psb"));
var tenant_1 = require("./contexts/tenant");
var cache_1 = require("./contexts/cache");
function useLookupPersonByName() {
    var _a;
    var MoopsyClient = (0, client_1.useClient)();
    var lookupByNameMutation = MoopsyClient.useMutation(LookupPersonByNameBP);
    var _b = react_1["default"].useState(null), results = _b[0], setResults = _b[1];
    var callLookup = function (name) {
        if (name.length < 2)
            return setResults(null);
        void lookupByNameMutation.call({ name: name }).then(function (res) {
            setResults(res);
        });
    };
    return {
        profiles: (_a = results === null || results === void 0 ? void 0 : results.profiles) !== null && _a !== void 0 ? _a : null,
        callLookup: callLookup
    };
}
exports.useLookupPersonByName = useLookupPersonByName;
var UserLookupMemCache = {};
var UserLookupMemCacheExpiry = {};
var UserLookupPromises = {};
function useLookupByUserId(userId) {
    var _this = this;
    var _a;
    var MoopsyClient = (0, client_1.useClient)();
    var Tenant = (0, tenant_1.useTenant)();
    var Cache = (0, cache_1.useCache)();
    var callLookup = MoopsyClient.useMutation(LookupPersonByUserIdBP).call;
    var _b = react_1["default"].useState(userId == null ? null : (_a = UserLookupMemCache[userId]) !== null && _a !== void 0 ? _a : null), data = _b[0], setData = _b[1];
    var onLookupChange = react_1["default"].useCallback(function (value) {
        setData(value);
        UserLookupMemCache[value.id] = value;
    }, []);
    MoopsyClient.useSubscribeToTopic(UserLookupPSB, "[".concat(Tenant, "]user.lookup/").concat(userId !== null && userId !== void 0 ? userId : ""), onLookupChange);
    var performLookup = react_1["default"].useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (userId == null) {
                        throw new Error("userId is null");
                    }
                    return [4 /*yield*/, callLookup({ userId: userId })];
                case 1:
                    data = _a.sent();
                    UserLookupMemCache[userId] = data.profile;
                    UserLookupMemCacheExpiry[userId] = Date.now() + 1000 * 5;
                    return [2 /*return*/, data];
            }
        });
    }); }, [callLookup, userId]);
    react_1["default"].useEffect(function () {
        var _a;
        if (userId == null) {
            return;
        }
        if (userId in UserLookupMemCache) {
            setData((_a = UserLookupMemCache[userId]) !== null && _a !== void 0 ? _a : null);
            if (UserLookupMemCacheExpiry[userId] >= Date.now()) {
                return;
            }
        }
        var cacheKey = "user-lookup-by-id/".concat(userId);
        void Cache.get(cacheKey).then(function (data) {
            if (data !== null) {
                UserLookupMemCache[userId] = data;
                UserLookupMemCacheExpiry[userId] = Date.now() + 1000 * 5;
                setData(data);
            }
            var promise = userId in UserLookupPromises
                ? UserLookupPromises[userId]
                : performLookup();
            UserLookupPromises[userId] = promise;
            void promise.then(function (data) {
                setData(data.profile);
            });
        });
    }, [callLookup, userId, performLookup]);
    var refresh = react_1["default"].useCallback(function () {
        void performLookup().then(function (data) {
            setData(data.profile);
        });
    }, [performLookup]);
    return data !== null
        ? {
            isReady: true,
            data: data,
            refresh: refresh
        }
        : {
            isReady: false,
            data: null,
            refresh: refresh
        };
}
exports.useLookupByUserId = useLookupByUserId;
